import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ParametrosDataService } from "src/app/services/parametros-data.service";
import { ParametrosKey } from "src/app/shared/enums/parametros.enum";
import { CustomizacaoSubmenuEnum } from "src/app/shared/enums/CustomizacaoSubmenuEnum";

@Component({
    selector: "app-gestor",
    templateUrl: "./gestor.component.html",
    styleUrls: ["./gestor.component.css"]
})
export class GestorComponent implements OnInit {
    constructor(
        private router: Router,
        private parametrosDataService: ParametrosDataService
    ) {}

    ngOnInit() {
        const canAccess = this.parametrosDataService.ShowSubmenu(
            CustomizacaoSubmenuEnum.gestores
        );
        if (!canAccess) {
            this.router.navigate(["accessdenied"]);
        }
    }
}
